var map = {
	"./en/LC_MESSAGES/messages": [
		1212,
		164
	],
	"./id/LC_MESSAGES/messages": [
		1213,
		165
	],
	"./vi/LC_MESSAGES/messages": [
		1214,
		166
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1070;
module.exports = webpackAsyncContext;